export const iconFontAwesomeHouseholdBath = (
	<i className="fa-solid fa-bath"></i>
);
